import { React, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Login from "./Pages/Login";
import LoginInternal from "./Pages/LoginInternal";
import DashBoardNew from "./Pages/Admin/DashBoardNew";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RegisterPage from "./Pages/RegisterPage";
import ForgotPasswordPage from "./Pages/ForgotPassword";
import OtpPage from "./Pages/Otp";
import "./i18";
import { Remove_User } from "./Redux/actions";
import NotfoundPage from "./Components/NotfoundPage";
//import Owners from "./Pages/Admin/Owners";
import Tenants from "./Pages/Tenants/Tenants";
import Bookings from "./Pages/Tenants/Bookings";
import TenantsInactive from "./Pages/Tenants/TenantsInactive";
import TenantsAgreementExpiring from "./Pages/Tenants/TenantsAgreementExpiring";
import Properties from "./Pages/Properties/Properties";
//import AllProperties from "./Pages/Admin/AllProperties";
import Occupancy from "./Pages/Admin/Occupancy";
//import PropComplaints from "./Pages/Admin/PropComplaints";
//import TenantsComplaints from "./Pages/Tenants/TenantsComplaints";
import Complaints from "./Pages/Admin/Complaints";
import Transactions from "./Pages/Admin/Transactions";
//import Prospects from "./Pages/Admin/Prospects";
import RoomOptions from "./Pages/Admin/RoomOptions";
import Floors from "./Pages/Admin/Floors";
import OccupiedRooms from "./Pages/Admin/OccupiedRooms";
import Beds from "./Pages/Admin/Beds";
//import AddTenant from "./Pages/Admin/AddTenant";
import ExtraCharges from "./Pages/Admin/ExtraCharges";
import SystemConfig from "./Pages/Admin/SystemConfig";
import Expenses from "./Pages/Finance/Expenses";
import NoAccess from "./Pages/NoAccess";
import RecurringExpenses from "./Pages/Properties/RecurringExpenses";
import { ExpensesType } from "./Pages/Admin/ExpensesType";
import Notifications from "./Pages/Admin/Notifications";
import AddBankPage from "./Pages/Admin/AddBankPage";
import AssetManagement from "./Pages/Admin/AssetManagement";
import FinanceDues from "./Pages/Finance/Dues";
import FinanceTrans from "./Pages/Finance/Transactions";
import ViewBeds from "./Pages/Properties/ViewBeds";
//import Ledger from "./Pages/Admin/Ledger";
import BedsDetails from "./Pages/Admin/BedsDetails";
import TenantDetails from "./Pages/Tenants/TenantDetails";
import SideNabar from "./Components/SideNavbar";
import TopNavbar from "./Components/TopNavbar";
import Leads from "./Pages/QuickActions/Leads";
import ActivityLogs from "./Pages/QuickActions/ActivityLogs";
import Staff from "./Pages/QuickActions/Staff";
import AdminStaff from "./Pages/QuickActions/AdminStaff";
import Notice from "./Pages/Admin/Notice";
import FloorRoom from "./Pages/Admin/FloorRoom";
import Assets from "./Pages/Assets";
import Settings from "./Pages/Settings/Settings";
import AssetMaintenance from "./Pages/Admin/AssetMaintenance";
import StaffAttendance from "./Pages/QuickActions/StaffAttendance";
import Reports from "./Pages/Reports/Reports";
import CreateReports from "./Pages/Reports/CreateReport";
import Logout from "./Components/Logout";
import IncomeExpenseSummary from "./Pages/Admin/IncomeExpenseSummary";
import VendorList from "./Pages/Admin/VendorList";
import AgreementsList from "./Pages/Properties/Lease/List";
import LandlordsAgreementExpiring from "./Pages/Properties/Lease/AgreementExpiring";
import LockinTracker from "./Pages/Properties/Lease/LockinTracker";
import VendorExpenseList from "./Pages/Admin/VendorExpenseList";
import FoodMenu from "./Pages/QuickActions/FoodMenu";
import ViewTenantAttendance from "./Pages/QuickActions/ViewTenantAttendance";
import MarkTenantAttendance from "./Pages/QuickActions/MarkTenantAttendance";
import TenantAttendance from "./Pages/Tenants/TenantAttendance";
import InventoryList from "./Pages/Properties/InventoryList";
import UnAvailableInventory from "./Pages/Properties/UnAvailableInventory";
import ExpenseSummary from "./Pages/Finance/ExpenseSummary";
import BankDetails from "./Pages/QuickActions/BankDetails";
import Partners from "./Pages/QuickActions/Partners";
import Requests from "./Pages/Admin/Requests";
import LandlordTransactions from "./Pages/Landlords/Transactions";
import LandlordDetail from "./Pages/Landlords/Details/Details";
import PendingDues from "./Pages/Landlords/PendingDues";
import LandlordsList from "./Pages/Landlords/List";
import BrokersList from "./Pages/Brokers/List";
import LandlordsPayments from "./Pages/Landlords/Payments";
import IncomeAndExpenseDetails from "./Pages/Admin/IncomeAndExpenseDetails";
import DailySummary from "./Pages/Admin/DailySummary";
import ElectricityBill from "./Pages/Properties/ElectricityBill";
import PropertyExtraCharges from "./Pages/Properties/PropertyExtraCharges";
import ProtectedRoute from "./utilities/ProtectedRoute";
import VacancyByProperty from "./Pages/Properties/VacancyByProperty";
import MissedRent from "./Pages/Tenants/MissedRent";
import TenantsAgreement from "./Pages/Tenants/TenantsAgreement";
import LandlordBankDetail from "./Pages/Landlords/LandlordBankDetail";
import Refund from "./Pages/Finance/Refund";
import Location from "./Pages/Admin/Location";
import LandlordDashboard from "./Pages/LandlordPortal/LandlordDashboard";
import LandlordPropertyList from "./Pages/LandlordPortal/PropertyList";
import LandlordDues from "./Pages/LandlordPortal/LandlordDues";
import LandlordCollection from "./Pages/LandlordPortal/LandlordCollection";
import ClientList from "./Pages/LandlordPortal/ClientList";
import LandlordAgreement from "./Pages/LandlordPortal/LandlordAgreement";
import ReserveTenantListing from "./Pages/Tenants/ReserveTenantListing";
import PropertyDetail from "./Pages/Properties/PropertyDetail";
import ClientPropertyDetails from "./Pages/Public/PropertyDetail";
import Deal from "./Pages/Deal/Deal";
import ClosedDeal from "./Pages/Deal/ClosedDeal";
import Revenue from "./Pages/Revenue/Revenue";
import PropertyListing from "./Pages/Admin/PropertyListing";
import Enquiries from "./Pages/Enquiries/Enquiries";
import ExpiringAgreement from "./Pages/Agreement/ExpiringAgreement";
import InventoryForm from "./Pages/Admin/InventoryForm";
import StampPaperListing from "./Pages/QuickActions/StampPaperListing";
import PreAgreement from "./Pages/Agreement/PreAgreement";
import OwnerDocuments from "./Pages/Documents/OwnerDocument";
import Receipt from "./Pages/Receipt/Receipt";
import CommissionReceiptForm from "./Pages/Receipt/ReceiptPage";
import ProfileDetail from "./Pages/ProfileDetails/ProfileDetail";
import SalarySlip from "./Pages/SalarySlip/SalarySlip";
import GeneratedSalarySlipPage from "./Pages/SalarySlip/GeneratedSalarySlipPage";

//import PropertyShareLink from "./Pages/Admin/PropertyShareLink";
// import PropertyDetails from "./Pages/Admin/PropertiesDetails";

function App() {
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const dispatch = useDispatch();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isSessionExpired = () => {
    if (user) {
      const expireAt = user?.expireAt;
      const currentTime = moment().valueOf();
      const isExpired = moment(currentTime).isAfter(expireAt);
      if (isExpired) {
        window.location.href = "/";
        dispatch(Remove_User());
      }
    }
  };

  useEffect(() => isSessionExpired(), []);

  if (!user)
    return (
      <>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
        <Routes>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/get-otp" element={<OtpPage />} />
          <Route path="/property-listing" element={<PropertyListing />} />
          {/* <Route path="properties-details" element={<PropertyDetail />} /> */}
          <Route path="/p/:id" element={<ClientPropertyDetails />} />
          {/* <Route path="/other" element={<PropertyDetailStatic />}/> */}
          <Route path="*" index element={<Login />} />
          <Route path="/login-internal" element={<LoginInternal />} />
          <Route path="/form/:id" element={<InventoryForm />} />
          <Route path="/free-payslip-generator" element={<SalarySlip />} />
          <Route path="/salary-slip/generated" element={<GeneratedSalarySlipPage />} />
        </Routes>
      </>
    );

  return (
    <>
      {showLogoutModal && (
        <Logout isLogout={showLogoutModal} setIsLogout={setShowLogoutModal} />
      )}

      <div className="flex h-screen overflow-hidden">
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
        <SideNabar onLogoutClick={() => setShowLogoutModal(true)} />
        {/* <div className="flex-1 transition-all duration-300 overflow-y-auto bg-gray-50"> */}
        <div className="flex flex-col flex-1 overflow-hidden">
          <TopNavbar />
          <div className="flex-1 overflow-y-auto bg-[#F6F7F8] rounded-2xl">
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* <Route
                path="/tenantdetails/:t/:id/:e?"
                element={<TenantDetails key={location.pathname} />}
              /> */}
              <Route path="/tenant/:tenantId" element={<TenantDetails />} />
              <Route path="*" element={<NotfoundPage />} />
              <Route path="/" element={<DashBoardNew />} />
              <Route path="/dashboard" element={<DashBoardNew />} />
              <Route path="/deals/pipeline" element={<Deal />} />
              <Route path="/deals/closed" element={<ClosedDeal />} />
              <Route path="/revenue" element={<Revenue />} />
              <Route path="stamp-paper" element={<StampPaperListing />} />
              <Route path="/pre-agreement" element={<PreAgreement />} />
              <Route path="invoice" element={<Receipt />}/>
              <Route path="/generateinvoice" element={<CommissionReceiptForm />}/>
              <Route path="/documents" element={<OwnerDocuments />}/>
              <Route path="/profile" element={<ProfileDetail />} />
              <Route
                path="/tenants/active"
                element={
                  <ProtectedRoute permission="MANANGE_TENANTS">
                    <Tenants />
                  </ProtectedRoute>
                }
              />
              <Route path="/tenants/bookings" element={<Bookings />} />
              <Route
                path="/tenants/moved-out"
                element={
                  <ProtectedRoute permission="MANANGE_TENANTS">
                    <TenantsInactive />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tenants/expiring-agreements"
                element={
                  <ProtectedRoute permission="MANANGE_TENANTS">
                    <TenantsAgreementExpiring />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/properties"
                element={
                  <ProtectedRoute permission="MANANGE_INVENTORY">
                    <Properties />
                  </ProtectedRoute>
                }
              />
              <Route path="/occupancy/:id" element={<Occupancy />} />
              <Route
                path="/finance/dues/"
                element={
                  <ProtectedRoute permission="MANANGE_DUES">
                    <FinanceDues />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/finance/collections/"
                element={
                  <ProtectedRoute permission="MANANGE_COLLECTIONS">
                    <FinanceTrans />
                  </ProtectedRoute>
                }
              />
              <Route path="/finance/expenses/"
                element={<ProtectedRoute permission="MANANGE_EXPENSES">
                  <Expenses />
                </ProtectedRoute>} />
              <Route
                path="/properties/recurring-exp"
                element={<ProtectedRoute permission="MANANGE_EXPENSES">
                  <RecurringExpenses />
                </ProtectedRoute>}
              />
              {/* <Route
              path="/complaints/:id/:clientId"
              element={<PropComplaints />}
            /> */}
              {/* <Route
              path="/tenantscomplaints/:id"
              element={<TenantsComplaints />}
            /> */}
              <Route
                path="/property/complaints"
                element={
                  <ProtectedRoute permission="MANANGE_COMPLAINTS">
                    <Complaints />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/complaints"
                element={
                  <ProtectedRoute permission="MANANGE_COMPLAINTS">
                    <Complaints />
                  </ProtectedRoute>
                }
              />
              <Route path="/assets" element={
                <ProtectedRoute permission="MANANGE_PROPERTY_ASSETS">
                  <Assets />
                </ProtectedRoute>
              } />
              <Route
                path="/transactions/:tenantId"
                element={<Transactions />}
              />
              {/* <Route path="allproperties" element={<AllProperties />} /> */}
              <Route path="roomoptions/:id" element={<RoomOptions />} />
              <Route path="floors/:id" element={<Floors />} />
              <Route path="/property/rooms" element={<ViewBeds />} />
              <Route path="/inventory" element={<ViewBeds />} />
              <Route path="beds/:roomId" element={<Beds />} />
              <Route
                path="occupiedroom/:propId/:roomId"
                element={<OccupiedRooms />}
              />
              {/* <Route
              path="addtenant/:propId/:roomId/:clientId"
              element={<AddTenant />}
            /> */}
              <Route path="extracharges" element={<ProtectedRoute permission="MANANGE_EXTRACHARGES">
                <ExtraCharges />
              </ProtectedRoute>} />
              <Route path="beddetails/:id" element={<BedsDetails />} />
              <Route path="/systemconfig" element={<SystemConfig />} />
              {/* <Route path="/charges/:clientId" element={<OwnerExtraCharges />} /> */}
              <Route path="/staff/:clientId" element={<Staff />} />
              <Route
                path="/staffs"
                element={
                  <ProtectedRoute permission="MANANGE_STAFF">
                    <AdminStaff />
                  </ProtectedRoute>
                }
              />

              {/* <Route path="/colleges" element={<Colleges />} /> */}
              <Route path="/notifications/:id" element={<Notifications />} />
              / <Route path="/expensestype" element={<ExpensesType />} />
              <Route path="/bank/:clientId" element={<AddBankPage />} />
              <Route path="/assets-management" element={<AssetManagement />} />
              <Route
                path="/asset/list/maintenance/:assetId/:propId"
                element={<AssetMaintenance />}
              />
              <Route path="/leads" element={<ProtectedRoute permission="MANANGE_LEADS">
                <Leads />
              </ProtectedRoute>} />
              <Route path="/activity-logs" element={<ActivityLogs />} />
              <Route path="/notice" element={<ProtectedRoute permission="MANANGE_SENDNOTICES">
                <Notice />
              </ProtectedRoute>} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/manage-flats-floors" element={<FloorRoom />} />
              <Route path="/reports" element={
                // <ProtectedRoute permission="MANANGE_REPORTS">
                <Reports />
              // </ProtectedRoute>
            } />
              <Route path="/create-reports" element={
                <ProtectedRoute permission="MANANGE_REPORTS">
                <CreateReports />
              </ProtectedRoute>} />
              <Route
                path="/props-financial-summary"
                element={<IncomeExpenseSummary />}
              />
              <Route
                path="/vendors"
                element={
                  <VendorList />
                }
              />
              <Route
                path="/vendors-expense/:vendorId"
                element={<VendorExpenseList />}
              />
              {user.userType === 1 &&
                <Route
                  path="/partners"
                  element={
                    <ProtectedRoute permission="MANANGE_STAFF">
                      <Partners />
                    </ProtectedRoute>
                  }
                />
              }
              {/* <Route path="/landlords" element={<AgreementsList />} /> */}
              <Route
                path="/owners/agreements"
                element={<AgreementsList />}
              />
              <Route
                path="/properties/expiring-agreements"
                element={<LandlordsAgreementExpiring />}
              />
              <Route
                path="/properties/lockin-tracker"
                element={<LockinTracker />}
              />
              <Route path="/food-menu" element={<FoodMenu />} />
              <Route
                path="/staff/attendance/:staffId"
                element={<ProtectedRoute permission="MANANGE_ATTENDANCES">
                  <StaffAttendance />
                </ProtectedRoute>}
              />
              <Route
                path="/view-attendance"
                element={<ProtectedRoute permission="MANANGE_ATTENDANCES">
                  <ViewTenantAttendance />
                </ProtectedRoute>}
              />
              <Route
                path="/mark-attendance/:id"
                element={<ProtectedRoute permission="MANANGE_ATTENDANCES">
                  <MarkTenantAttendance />
                </ProtectedRoute>}
              />
              <Route
                path="/tenant-attendance/:tenantId"
                element={<ProtectedRoute permission="MANANGE_ATTENDANCES">
                  <TenantAttendance />
                </ProtectedRoute>}
              />
              <Route path="/inventory/operational" element={<InventoryList />} />
              <Route path="/inventory/unavailable" element={<UnAvailableInventory />} />
              <Route path="/expense-summary" element={<ExpenseSummary />} />
              <Route path="/enquiries" element={<Enquiries />}/>
              <Route
                path="/bank-details"
                element={
                  <ProtectedRoute permission="MANANGE_BANKS">
                    <BankDetails />
                  </ProtectedRoute>
                }
              />
              <Route path="/requests" element={<ProtectedRoute permission="MANANGE_REQUESTS">
                <Requests />
              </ProtectedRoute>} />

              <Route
                path="/landlord/transactions"
                element={
                  <ProtectedRoute permission="MANANGE_LANDLORD">
                    <LandlordTransactions />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/landlord/details"
                element={
                  <ProtectedRoute permission="MANANGE_LANDLORD">
                    <LandlordDetail />
                  </ProtectedRoute>
                }
              />

              <Route path="/landlord/pending-dues" element={
                <ProtectedRoute permission="MANANGE_LANDLORD">
                  <PendingDues />
                </ProtectedRoute>
              } />
              
              <Route path="/owners" element={
                // <ProtectedRoute permission="MANANGE_LANDLORD">
                  <LandlordsList />
                // </ProtectedRoute>
              } />
              <Route path="/brokers" element={
                // <ProtectedRoute permission="MANANGE_LANDLORD">
                  <BrokersList />
                // </ProtectedRoute>
              } />
              <Route
                path="/landlords/payments"
                element={
                  <ProtectedRoute permission="MANANGE_LANDLORD">
                    <LandlordsPayments />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/income-expense"
                element={<IncomeAndExpenseDetails />}
              />
              <Route path="/daily-summary/:p?" element={<DailySummary />} />
              <Route path="/electricity-bill" element={<ElectricityBill />} />
              <Route
                path="/property-extra-charges"
                element={<PropertyExtraCharges />}
              />
              <Route
                path="/vacancy-by-property"
                element={<VacancyByProperty />}
              />
              <Route
                path="/missed-rent"
                element={<MissedRent />}
              />
              <Route
                path="/tenants/agreement"
                element={<TenantsAgreement />}
              />
              <Route
                path="/landlord/bank-details"
                element={<LandlordBankDetail />}
              />
              <Route
                path="/finance/refund"
                element={<ProtectedRoute permission="MANANGE_EXPENSES">
                  <Refund />
                </ProtectedRoute>}
              />
              <Route
                path="/locations"
                element={<Location />}
              />
              <Route
                path="/landlord/dashboard"
                element={<LandlordDashboard />}
              />
              <Route
                path="/landlord/property-list"
                element={<LandlordPropertyList />}
              />
              <Route
                path="/landlord/dues"
                element={<LandlordDues />}
              />
              <Route
                path="/landlord/collections"
                element={<LandlordCollection />}
              />
              <Route
                path="/landlord/client"
                element={<ClientList />}
              />
              <Route
                path="/landlord/agreement"
                element={<LandlordAgreement />}
              />
              <Route
                path="/reserve/tenants"
                element={<ReserveTenantListing />}
              />
              <Route path="/inventory/details" element={<PropertyDetail />} />
              <Route path="/expiringagreement" element={<ExpiringAgreement />}/>

              <Route path="/no-access" element={<NoAccess />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
